"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FSider = void 0;
const react_1 = __importStar(require("react"));
const ferrum_brand_logo_png_1 = __importDefault(require("../../assets/images/ferrum-brand-logo.png"));
const FSider = ({ siderLogo = ferrum_brand_logo_png_1.default, showLogo = true, children = undefined, }) => {
    const [asideToggle, setAsideToggler] = (0, react_1.useState)(true);
    const [FsilderLayoutState, setFsilderLayoutState] = (0, react_1.useState)(true);
    const [windowDimensions, setWindowDimensions] = (0, react_1.useState)({
        width: window.innerWidth,
        height: window.innerHeight,
    });
    (0, react_1.useEffect)(() => {
        const fLayout = document.querySelector(".f-layout");
        if (FsilderLayoutState) {
            fLayout.classList.add("f-layout-expanded");
            fLayout.classList.remove("f-layout-collapsed");
        }
        else {
            fLayout.classList.remove("f-layout-expanded");
            fLayout.classList.add("f-layout-collapsed");
        }
    }, [FsilderLayoutState]);
    (0, react_1.useLayoutEffect)(() => {
        const handleResize = () => {
            const { innerWidth: width, innerHeight: height } = window;
            setWindowDimensions({ width, height });
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    (0, react_1.useEffect)(() => {
        if (windowDimensions.width < 991) {
            setAsideToggler(false);
        }
        else {
            setAsideToggler(true);
        }
    }, [windowDimensions]);
    return (react_1.default.createElement("div", { className: `f-sider-outer` },
        react_1.default.createElement("div", { className: `desktop-aside-toggler btn btn-primary ${asideToggle ? "open" : ""}`, onClick: () => {
                setAsideToggler(!asideToggle);
                setFsilderLayoutState(!FsilderLayoutState);
            } },
            react_1.default.createElement("span", null),
            react_1.default.createElement("span", null),
            react_1.default.createElement("span", null)),
        react_1.default.createElement("aside", { className: `f-sider f-layout-component ${asideToggle ? "sider-expanded" : "sider-collapsed"}` },
            react_1.default.createElement("div", { className: `f-mobile mobile-aside-toggler ${asideToggle ? "open" : ""}`, onClick: () => setAsideToggler(!asideToggle) },
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null),
                react_1.default.createElement("span", null)),
            showLogo === true && siderLogo && (react_1.default.createElement("div", { className: "f-logo" },
                react_1.default.createElement("img", { src: siderLogo, alt: "Logo" }))),
            react_1.default.createElement("div", { className: "f-sider-items" }, children))));
};
exports.FSider = FSider;
//# sourceMappingURL=Fsider.js.map